import React from "react";
import { Link } from "react-router-dom";
import "../styles/hero.css";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay">
        <div className="container hero-content fade-in">

          <h1>
            Connecting Global Markets <br />
            <span>with Quality Industrial Products</span>
          </h1>

          <div className="hero-accent"></div>

          <p>
            Reliable supply of industrial, safety, and trading solutions tailored
            to meet diverse industry needs.
          </p>

          <div className="hero-actions">
            <Link to="/products" className="btn btn-primary">
              View Products
            </Link>

            {/* <Link to="/contact" className="btn btn-secondary">
              Send Inquiry
            </Link> */}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;
